import React, { useState } from 'react'
import { Menu } from '@softwaredev_cegeka/stix-core/dist/components'
import {
    debouncedLoadData,
    sortData,
    sortObjectToString,
} from 'src/utils/utils'

import './entityTable.scss'
import EntityTable from './EntityTable'
import { DataTableSortableHeader } from '@softwaredev_cegeka/stix-data-table'
import { Link } from 'react-router-dom'
import { Icon } from '@softwaredev_cegeka/stix-core'

function ApplicationTable({
    data,
    loading,
    setParams,
    params,
    rowSelectHandler,
    isGlobalAdmin,
    deleteAction,
}) {
    let [sort, setSort] = useState({ column: null, direction: null })
    const handleColumnSort = columnName => sortingDirection => {
        sortData(columnName, sortingDirection, params, setSort, setParams)
    }
    const columns = [
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'name' ? sort.direction : undefined
                        }
                        onSort={handleColumnSort('name')}
                    >
                        Name
                    </DataTableSortableHeader>
                )
            },
            accessor: 'name',
        },
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'key' ? sort.direction : undefined
                        }
                        onSort={handleColumnSort('key')}
                    >
                        Key
                    </DataTableSortableHeader>
                )
            },
            accessor: 'key',
        },
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'description'
                                ? sort.direction
                                : undefined
                        }
                        onSort={handleColumnSort('description')}
                    >
                        Description
                    </DataTableSortableHeader>
                )
            },
            accessor: 'description',
        },
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'contact_email'
                                ? sort.direction
                                : undefined
                        }
                        onSort={handleColumnSort('contact_email')}
                    >
                        Contact email
                    </DataTableSortableHeader>
                )
            },
            accessor: 'contact_email',
        },
    ]

    // if any column that is a relationship and not a direct property to the application action object
    // gets added here, it shouldn't be passed in the handleGlobalFilter function
    const columnsToFilter = [
        {
            column: 'name',
        },
        {
            column: 'key',
        },
        {
            column: 'description',
        },
        {
            column: 'contact_email',
            label: 'contact email',
        },
    ]

    let getMenuOptions = selectedRow => {
        let options = [
            {
                as: () => (
                    <Link
                        className="stix-dropdown-item"
                        to={`/application-form/${selectedRow.row.original.id}`}
                    >
                        <Icon icon="edit" title="Edit application" />
                    </Link>
                ),
            },
        ]

        if (isGlobalAdmin) {
            options.push({
                name: 'Remove',
                icon: 'delete',
                onClick: () => {
                    let r = window.confirm(
                        `You are permanently removing application ${selectedRow.row.original.name}. Are you sure?`
                    )
                    if (r === true) {
                        deleteAction(
                            selectedRow.row.original.id,
                            selectedRow.row.original.name
                        )
                    }
                },
            })
        }
        return options
    }

    if (process.env.REACT_APP_ENABLE_EDIT_TENANT_FUNCTIONALITY === 'true') {
        columns.push({
            Header: () => null,
            id: 'menu',
            Cell: selectedRow => (
                <Menu.Option
                    contextMenu={getMenuOptions(selectedRow)}
                    icon={'actions-vert'}
                />
            ),
            width: '1%',
        })
    }

    function handleFilterChange(entries) {
        // Reset to show al results after clear filters is clicked.
        if (entries.length === 0) {
            setParams({})
            return
        }

        const sortString = sortObjectToString(sort)

        // Update params with new selected filter and send them back to the route.
        entries.forEach(item => {
            Object.entries(item).forEach(([key, value]) => {
                params[key + '_like'] = value.toString()
            })
        })

        if (sortString) {
            params.sort = sortString
        }

        setParams(params)
    }

    function handleGlobalFilter(value) {
        // check all columns on entry
        columnsToFilter.forEach(col => {
            params[col.column + '_like'] = value.toString()
        })
        params.use_or = true
        debouncedLoadData(params, setParams)
    }

    return (
        <EntityTable
            loading={loading}
            data={data}
            onSingleRowSelect={selectedRowObj => {
                rowSelectHandler(selectedRowObj)
            }}
            columns={columns}
            columnsTofilter={columnsToFilter}
            onColumnFilter={handleFilterChange}
            onGlobalFilter={handleGlobalFilter}
        />
    )
}

export default ApplicationTable
